import React, { FunctionComponent } from "react"
import { Controller } from "react-hook-form"
import AsyncCreatableSelectInput from "./AsyncCreatableSelectInput"
import { iTag } from "../../../definitions/Tags"
import { get, post } from "../../../store/data/actions"

interface iProps {
  group: string
  name: string
  label?: string
  placeholder?: string
  isMulti?: boolean
}

const AsyncCreatableTag: FunctionComponent<iProps> = ({
  group,
  name,
  label,
  placeholder,
  isMulti = true,
}) => {
  const loadStyles = async (input: string) => {
    try {
      const result = await get<iTag[]>({
        link: "/v1/tags",
        query: { name: input, group },
      })

      return result.map((tag) => ({ value: tag._id, label: tag.name }))
    } catch (e) {
      console.error(e)
    }
  }

  const createStyle = async (input: string) => {
    const data = await post<Partial<iTag>>({
      link: "/v1/create-tag",
      data: { name: input, group },
    })
    return { value: data._id, label: data.name }
  }

  return (
    <>
      <Controller
        // as={AsyncCreatableSelectInput}
        name={name}
        render={({ onChange, value }) => (
          <AsyncCreatableSelectInput
            value={value}
            onChange={onChange}
            name={name}
            label={label}
            placeholder={placeholder}
            isMulti={isMulti}
            defaultOptions
            loadOptions={loadStyles}
            onCreateOption={createStyle}
          />
        )}
      />
    </>
  )
}

export default AsyncCreatableTag
